"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var TooltipEntity_1 = __importDefault(require("../decorators/TooltipEntity"));
var wagtailConfig_1 = require("../../../config/wagtailConfig");
var documentIcon = react_1["default"].createElement(Icon_1["default"], { name: "doc-full" });
var missingDocumentIcon = react_1["default"].createElement(Icon_1["default"], { name: "warning" });
var Document = function (props) {
    var entityKey = props.entityKey, contentState = props.contentState;
    var data = contentState.getEntity(entityKey).getData();
    var url = data.url || null;
    var icon;
    var label;
    if (!url) {
        icon = missingDocumentIcon;
        label = wagtailConfig_1.STRINGS.MISSING_DOCUMENT;
    }
    else {
        icon = documentIcon;
        label = data.filename || '';
    }
    return (react_1["default"].createElement(TooltipEntity_1["default"], __assign({}, props, { icon: icon, label: label, url: url })));
};
Document.propTypes = {
    entityKey: prop_types_1["default"].string.isRequired,
    contentState: prop_types_1["default"].object.isRequired,
};
exports["default"] = Document;
